module.exports = __webpack_public_path__ + "img/powerline-dark.8da7636f.png";